module.exports = __webpack_public_path__ + "img/house-icon.b7a8f149.svg";